// ============================================================
// A VEHICLE'S FACING RING, DRAWN (plan design-gaps, V1): the four arcs round
// the hull on the ground, each with the armour it presents printed outside it,
// the arc the shooter stands in lit, and the chevron at the bow. The geometry
// is the engine's (engine/display/facingRing), projected by the tokens layer.
// ============================================================

import clsx from '../../utils/clsx';
import type { ScreenXY } from './markerGeometry';
import styles from '../../styles/Display.module.css';
import { pointsAttr } from '../../engine/display/svgPath';

type XY = Pick<ScreenXY, 'x' | 'y'>;

/** The ring as the screen sees it this frame. */
export interface ScreenFacingRing {
  arcs: { id: string; armour: number; lit: boolean; points: XY[]; label: XY }[];
  bow: XY[];
}

/** The hull's facing ring: four arcs with their armour, the shooter's lit, and the bow. */
export default function TokenFacingRing({ id, ring }: { id: string; ring: ScreenFacingRing }) {
  return (
    <g data-testid={`facing-ring-${id}`} className={styles.facingRing} pointerEvents="none">
      {ring.arcs.map((a) => (
        <g key={a.id} data-facing-arc={a.id} data-lit={a.lit || undefined} className={clsx(a.lit && styles.facingLit)}>
          <polyline points={pointsAttr(a.points)} />
          <text x={a.label.x} y={a.label.y} textAnchor="middle" dominantBaseline="middle">
            {a.armour}
          </text>
        </g>
      ))}
      <polyline className={styles.facingBow} points={pointsAttr(ring.bow)} data-testid={`facing-bow-${id}`} />
    </g>
  );
}
